import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root',
})
export class ErrorModalService {
	public isModalVisible = false;

	public openErrorModal() {
		this.isModalVisible = true;
	}

	public closeErrorModal() {
		this.isModalVisible = false;
	}
}